import { ViewCountKeyEnum } from '@ztechapps/common.contract'
import { useViewCount, type UseViewCountResult } from '@ztechapps/common.hook'

/**
 * Hook for managing Product view counts.
 * Automatically increments the view count when the product is viewed.
 *
 * @param productId - The ID of the product
 * @returns viewCount, increment, loading, error
 *
 * @example
 * const { viewCount } = useProductViewCount(productId)
 */
export function useProductViewCount(productId: string): UseViewCountResult {
  return useViewCount({
    key: ViewCountKeyEnum.Product,
    value: productId,
  })
}
